<style scoped lang="scss">
@import "../mobile";
</style>
<template>
  <div class="wrap-app bg_gray">
    <div class="common-top">
      <img src="@/assets/images/mobile/icon_back.png" class="icon-back" @click="$router.go(-1)">
      <div class="search-box" @click="$router.push('/sunger/search')">
        <input placeholder="请输入订单编号" readonly/>
        <img src="@/assets/images/mobile/icon_search.png" class="icon-search">
      </div>
    </div>
    <ul class="status-tabs">
      <li :class="{active:index === currentTab}" v-for="(item, index) in statusTabs" :key="index" @click="changeTab(index, item.label)">{{item.name}}</li>
    </ul>
    <div class="order">
      <ul class="order-lists"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
          immediate-check="false">
        <li v-for="item in orderLists" :key="item.value.id" @click="toDetails(item.value.id)">
          <div class="top">
            <div>订单号：<span class="text-primary">{{item.value.no}}</span></div>
            <span class="status status-primary">{{item.value.orderStatusName}}</span>
          </div>
          <div class="con">
            <div class="title">测序反应数<span class="fr">x{{item.totalNum}}</span></div>
            <div class="price">应付金额：￥{{item.value.settlementAmount | amount}}<span class="fr">{{item.value.createTime | rTime}}</span></div>
          </div>
        </li>
      </ul>
      <div class="btn-more" v-show="loading">加载中</div>
      <div class="btn-more" v-show="total === orderLists.length && orderLists.length > 0">没有更多了</div>
      <div class="no-data" v-show="orderLists.length === 0">暂无相关订单</div>
    </div>
  </div>
</template>

<script>
import { sequencingOrders } from '@/services/api.index'
export default {
  data () {
    return {
      statusTabs: [
        {name: '全部订单', label: ''},
        {name: '进行中', label: 'ING'},
        {name: '已完成', label: 'OK'}
      ],
      currentTab: 0,
      orderLists: [],
      status: '',
      page: 0,
      pageSize: 10
    }
  },
  created() {
    this.getOrders()
  },
  methods: {
    changeTab (index, label) {
      this.currentTab = index
      this.status = label
      this.page = 0
      this.orderLists = []
      this.getOrders()
    },
    getOrders () {
      const { page, pageSize, status } = this
      const memberInfo = this.baseMethods.getLocalObj('memberInfo')
      sequencingOrders(page, pageSize, '', '', '', status, memberInfo.id).then(res => {
        res.data.list.map(item => {
          item.value.orderStatusName = this.baseMethods.orderStatus(item.userWebOrderStatus)
        })
        this.loading = false
        this.orderLists = this.orderLists.concat(res.data.list)
        this.total = res.data.totalCount
        if (this.orderLists.length === this.total && this.orderLists.length !== 0) {
          this.loaded = true
        }
      })
    },
    loadMore () {
      if (!this.loaded) {
        this.loading = true
        setTimeout(() => {
          this.page++
          this.getOrders()
        }, 2000)
      }
    },
    // 跳转到详情页
    toDetails (id) {
      this.$router.push(`/sunger/order_details?id=${id}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/sunger/index.vue